import UpdateUser from '../organisms/UpdateUser'
import Layout from '../../../../layout/Layout'
import HeaderPageSection from '../../../../components/molecules/HeaderPageSection/HeaderPageSection'
import { useParams } from 'react-router-dom'

export default function UpdateUserPage() {
    const { id } = useParams<{ id: string }>()
    // const {user} = useUserById(id)

    return (
        <Layout>
            <HeaderPageSection title="Editar Usuario" showGoBack={true} />
            <div>
                <UpdateUser userId={id} />
            </div>
        </Layout>
    )
}
